// Init
import React from "react";

// Importing Components
import NavBar from "../components/NavBar";
import HorizontalLinearStepper from "../components/StepFormContainer";

// Home Component
export default function Home() {
  return (
    <div>
      <NavBar />
     
    </div>
  );
}
